import React from 'react';
import Popover from '@material-ui/core/Popover';
import ListItemText from '@material-ui/core/ListItemText';
import useStyles from './styles'
import { ListItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

export default function SimplePopover({id, open, anchorEl, route, handleClose, active, handleActivate, user}) {
  const classes = useStyles();
  const history = useHistory();

  const onHandleClose = () => {
    if (handleClose()) handleClose();
    if (route) history.push(route);

  }

  return (
    <div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onHandleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <span className={classes.link}>
          <ListItem button={true} onClick={onHandleClose}>
                <ListItemText className={classes.itemText} id="user-manager-action-edit-permission" data-cy="user-manager-action-edit-permission">
                  {user.type==="driver" ?"Visualizar Dados":"Editar permissões"}
                </ListItemText>
          </ListItem>
        </span>
        <ListItem button={true} onClick={handleActivate}>
              <ListItemText className={classes.itemText} id="user-manager-action-deactivate-user" data-cy="user-manager-action-deactivate-user">
                {active ? "Desativar usuário" : "Ativar usuário"}
              </ListItemText>
        </ListItem>
      </Popover>
    </div>
  );
}
